import { PositionChat } from "./position_chat";

export class PositionChats extends Array<PositionChat> {
  constructor(positionChats?: PositionChat[]) {
    super();
    if (positionChats instanceof Array) {
      positionChats.forEach((positionChat) => this.push(positionChat));
    }
  }
}
